import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";
import Header from "./Header";
import HomeTab from "./HomeTab";
import ProjectPage from "../pages/ProjectPage";
import NotFoundPage from "../pages/NotFoundPage";
import ProjectSettingPage from "../pages/ProjectSettingPage";
import ProjectCreatePage from "../pages/new/ProjectCreatePage";
import SelectAlgorithmPage from "../pages/SelectAlgorithmPage";
import AnalysisMainPage from "../pages/AnalysisMainPage";
import ProjectReportPage from "../pages/ProjectReportPage";
import TrainHistoryPage from "../pages/TrainHistoryPage";
import { KeyMappingContent } from "./setting/KeyMappingContent";
import { ColorThemeProvider } from "./report/setting/ColorThemeContext";
import { steps_1, steps_1_2, steps_2, steps_3, steps_4 } from "./joyride/step1";
import { isTutorialState, stepIndexState, currentStepsState, dataLoadingState } from "../recoil/index";
import { useRecoilState } from "recoil";
import { saveTutorialProgress } from "../utils/tutorialUtil";
import TutorialController from "./joyride/TutorialController";

import CBORImageViewer from "./test/CBORImageViewer"; // remove
import TrainCreatePage from "../pages/TrainCreatePage";
import ProjectMain from "./project/ProjectMain";
import Layout from "../pages/Layout";
import DashboardPage from "../pages/main/DashboardPage";
import NoticePage from "../pages/main/NoticePage";
import MainNoticeFormPage from "../pages/main/NoticeFormPage";
import DatasetPage from "../pages/main/DatasetPage";
import DatasetCreatePage from "../pages/DatasetCreatePage";
import ModelFormPage from "./inspModel/ModelFormPage.js";
import InspRuleFormPage from "./inspRule/InspRuleFormPage.js";
import ServerFormPage from "./serverManage/ServerFormPage.js";
import NoticeFormPage from "./notice/NoticeFormPage.js";
import ProjectMainPage from "../pages/new/ProjectMainPage";
import ProjectHeader from "./new/ProjectHeader";
import ProjectHistoryPage from "../pages/new/ProjectHistoryPage";
import ReportPage from "../pages/new/ReportPage";
import ProjectLayout from "../pages/new/ProjectLayout";
import OptionPopupPage from "../pages/new/OptionPopupPage";
import InspectionPage from "../pages/new/InspectionPage";
import InspectionStatusPage from "../pages/new/InspectionStatusPage";
import UserSettingPage from "../pages/UserSettingPage";
import { StatusProvider } from "../context/InspStatusContext";

export default function Routers() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isRun, setIsRun] = useRecoilState(isTutorialState);
  const [stepIndex, setStepIndex] = useRecoilState(stepIndexState);
  const [currentSteps, setCurrentSteps] = useRecoilState(currentStepsState);
  const [isLoadingData, setIsLoadingData] = useRecoilState(dataLoadingState);
  const [activeMenu, setActiveMenu] = useState("dashboard");
  // const navigate = useNavigate();

  // useEffect(() => {
  //   const resumeTutorial = JSON.parse(
  //     localStorage.getItem("tutorialProgress") || "{}"
  //   );

  //   // ✅ location.state 통해 튜토리얼 이어서 실행할지 결정
  //   if (location.state?.continueTutorial && isLoadingData) {
  //     console.log("location.state", location.state);
  //     switch (location.state?.prevIndex) {
  //       case 0:
  //         setCurrentSteps(steps_1_2);
  //         break;
  //       case 1:
  //         setCurrentSteps(steps_2);
  //         break;
  //       case 2:
  //         setCurrentSteps(steps_3);
  //         break;
  //       default:
  //         break;
  //     }
  //     setStepIndex(0);
  //     setIsRun(true);
  //     setIsLoadingData(false);
  //   }
  // }, [isLoadingData]);

  const handleTourCallback = (data: any) => {
    const { action, index, status, type } = data;
    // console.log("location.pathname", location.pathname);
    // console.log("action", action);
    // console.log("index", index);
    // console.log("status", status);
    // console.log("type", type);

    const lastStep = currentSteps.length - 1;
    const saved = JSON.parse(localStorage.getItem("tutorialProgress") || "{}");

    // 첫번째 스텝
    if (location.pathname === "/home" && action === "next" && index === lastStep) {
      saveTutorialProgress(location.pathname, 0);
      navigate("/project/254", {
        state: { continueTutorial: true, prevIndex: 0 },
      });
    }

    // 두번째 스텝
    if (location.pathname === "/project/254" && action === "next" && status === "finished" && index === lastStep) {
      saveTutorialProgress(location.pathname, 1);
      navigate("/home");
      setTimeout(() => {
        navigate("/project/255", {
          state: { continueTutorial: true, prevIndex: 1 },
        });
      }, 500);
    }

    // 세번째 스텝
    if (
      location.pathname === "/project/255" &&
      action === "next" &&
      status === "finished" &&
      index === lastStep
      // index === 8
    ) {
      navigate("/home");
      saveTutorialProgress(location.pathname, 2);

      setTimeout(() => {
        navigate("/project/258", {
          state: { continueTutorial: true, prevIndex: 2 },
        });
      }, 500);
    }

    // 네번째 스텝
    if (location.pathname === "/project/258" && action === "next" && status === "finished" && index === lastStep) {
      saveTutorialProgress(location.pathname, 3);
      navigate("/project/16/report", {
        state: { continueTutorial: true, prevIndex: 3 },
      });
    }

    // ✨ 공통 종료 처리
    if (status === "finished" || status === "skipped" || action === "close") {
      console.log("종료됨");
      // localStorage.removeItem("tutorialProgress");
      setCurrentSteps([]);
      // setStepIndex(0);
      setIsRun(false);
      return;
    }
  };

  return (
    <>
      <Routes>
        <Route>
          <Route index element={<Navigate to="/login" />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/main" element={<Layout />}>
            <Route path="/main/dashboard" element={<DashboardPage />} />
            <Route path="/main/notices" element={<NoticePage />} />
            <Route path="/main/notices/create" element={<MainNoticeFormPage />} />
            <Route path="/main/notices/:id/edit" element={<MainNoticeFormPage />} />
            <Route path="/main/dataset" element={<DatasetPage />} />
            <Route path="/main/projects" element={<ProjectMain />} />
            <Route path="/main/inspection" element={<InspectionPage />} />
            <Route
              path="/main/status"
              element={
                <StatusProvider>
                  <InspectionStatusPage />
                </StatusProvider>
              }
            />
            <Route path="/main/setting" element={<Navigate to="/main/setting/user" replace />} />
            <Route path="/main/setting/user" element={<UserSettingPage />} />
            <Route path="/main/projects/create" element={<ProjectCreatePage />} />
            <Route path="/main/training/create" element={<TrainCreatePage />} />
          </Route>
          <Route path="/main/project/:id" element={<ProjectLayout />}>
            <Route index element={<ProjectMainPage />} />
            <Route path="analysis" element={<AnalysisMainPage />} />
            <Route path="analysis/:label" element={<ProjectMainPage />} />
            <Route path="history" element={<ProjectHistoryPage />} />
            <Route path="report" element={<ReportPage />} />
            <Route path="setting" element={<ProjectSettingPage />} />
          </Route>
          <Route path="/option-popup" element={<OptionPopupPage />} />
          <Route element={<Header />}>
            <Route path="/home" element={<HomeTab />} />
            <Route path="/project/:id" element={<ProjectPage />} />
            <Route path="/project/:id/analysis" element={<AnalysisMainPage />} />
            <Route path="/projects/create" element={<ProjectCreatePage />} />

            <Route path="/project/:id/setting" element={<ProjectSettingPage />} />
            <Route path="/project/:id/settings/general" element={<ProjectSettingPage />} />
            <Route path="/project/:id/history" element={<TrainHistoryPage />} />
            <Route path="/project/:id/report" element={<ProjectReportPage />} />

            {/* 삭제 예정 (step=1 ~ step=3) */}
            <Route path="/project/:id/analysis/step=1" element={<SelectAlgorithmPage />} />
            <Route path="/project/:id/analysis/step=2" element={<SelectAlgorithmPage />} />
            <Route path="/project/:id/analysis/step=3/:algoId" element={<SelectAlgorithmPage />} />
            <Route path="/project/:id/analysis/:label" element={<ProjectPage />} />
            <Route path="/project/:id/analysis/pre_class" element={<SelectAlgorithmPage />} />

            <Route path="/train/create" element={<TrainCreatePage />} />
            <Route path="/datasets/create" element={<DatasetCreatePage />} />
            <Route path="/insp-rule/:id" element={<InspRuleFormPage />} />
            <Route path="/insp-rule/create" element={<InspRuleFormPage />} />
            <Route path="/datasets/edit/:id" element={<DatasetCreatePage />} />
            {/* <Route
              path="/project/:id/setting/key_mapping"
              element={<KeyMappingContent labelList={[]} id={":id"} />}
            /> */}
            <Route path="/setting" element={<ProjectSettingPage />} />
            <Route path="/insp-model/:id" element={<ModelFormPage />} />
            <Route path="/insp-model/create" element={<ModelFormPage />} />
            <Route path="/server-manage/create" element={<ServerFormPage />} />
            <Route path="/server-manage/:id" element={<ServerFormPage />} />
            <Route path="/notice/:id" element={<NoticeFormPage />} />
            <Route path="/cbor-test" element={<CBORImageViewer />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      {/* <ProductTour onCallback={handleTourCallback} /> */}
      <TutorialController />
      {/* <Tour
        steps={steps}
        isOpen={isRun}
        onRequestClose={() => setIsRun(false)}
      /> */}
    </>
  );
}
